import React from 'react';

// Matches the mockup's modal-body/modal-footer rhythm: centered icon/heading
// content, then a footer row of action buttons — left-aligned for a single
// dismiss action (success/error dialogs), right-aligned for cancel+confirm
// (the initial confirm dialog).
const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: '8px 0 24px',
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingTop: 8,
  },
  button: {
    minWidth: 160,
  },
  footerRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    paddingTop: 24,
  },
};

export default styles;
